import { RadioCardProps } from '../../types';

/**
 * A reusable radio button styled as a card with visual feedback.
 * Used for selection UI patterns throughout the checkout flow.
 */
export function RadioCard({
  name,
  value,
  checked,
  onChange,
  children,
  className = '',
}: RadioCardProps) {
  return (
    <label
      className={`block border-2 rounded-lg p-4 cursor-pointer transition-all ${
        checked
          ? 'border-blue-600 bg-blue-50'
          : 'border-gray-200 hover:border-gray-300'
      } ${className}`}
    >
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className="sr-only"
      />
      {children}
    </label>
  );
}
